<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/PL_serpref">Series preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/PL_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/PL_abbrev">Abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/PL_ch01"><span class="bold2">1 Introduction and statement of the problem</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch01#sigil_toc_id_2">The problems of the book of Job</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch01#sigil_toc_id_3">A word on myth</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/PL_ch02"><span class="bold2">2 Job’s tragedy (chs. 1–2) and the failure of the debate with his friends (chs. 3–37)</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_5">Job’s integrity, the Accuser’s question and Job’s costly worship (Job 1 – 2)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_6">The debate between Job and his friends: round one (chs. 4–14)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_7">Reflections on the first round of the debate (chs. 4–14)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_8">Round two of the debate (chs. 15–21)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_9">Round three of the debate (chs. 22–27)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_10">Wisdom’s inaccessibility (ch. 28) and Job’s final assertion of innocence (chs. 29–31)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_11">Elihu (chs. 32–37)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PL_ch02#sigil_toc_id_12">Evaluating the debate between Job and his friends</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PL_ch03" title="Link target outside of Sample"><span class="bold2">3 Y</span><span class="smallcaps_bold2">hwh</span><span class="bold2">’s first speech and his rule over creation (Job 38:1 – 40:5)</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_14" title="Link target outside of Sample">‘Then the L<span class="smallcaps_rom2">ord</span> answered . . . and said’ (38:1): <span class="smallcaps_rom2">yhwh</span>’s introduction</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_15" title="Link target outside of Sample">Y<span class="smallcaps_rom2">hwh</span>’s opening challenge to Job (38:2–3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_16" title="Link target outside of Sample">Who was it that founded the earth? (38:4–7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_17" title="Link target outside of Sample">Rhetorical questions and the issue of tone</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_18" title="Link target outside of Sample">The ‘swaddling’ of the raging sea (38:8–11)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_19" title="Link target outside of Sample">The moral significance of the sunrise (38:12–15)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_20" title="Link target outside of Sample">God’s tour through different parts of the cosmos (38:16–38) and the animals inhabiting it (38:39 – 39:30)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_21" title="Link target outside of Sample">Human limits, divine goodness and the continuing presence of evil: the significance of <span class="smallcaps_rom2">yhwh</span>’s first speech to Job</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_22" title="Link target outside of Sample">A significant rival interpretation of <span class="smallcaps_rom2">yhwh</span>’s first speech</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch03#sigil_toc_id_23" title="Link target outside of Sample">Job’s response (40:1–5): Is he satisfied? Is the reader?</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PL_ch04" title="Link target outside of Sample"><span class="bold2">4 Y</span><span class="smallcaps_bold2">hwh</span><span class="bold2">’s second speech and the defeat of Leviathan (Job 40:6 – 41:34)</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_25" title="Link target outside of Sample">‘Will you break my justice?’2 (40:6–8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_26" title="Link target outside of Sample">The preparation of the divine warrior (40:9–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_27" title="Link target outside of Sample">Behemoth: the ‘Superbeast’ (40:15–24)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_28" title="Link target outside of Sample">Leviathan: the twisting, fleeing serpent (41:1–34)26</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_29" title="Link target outside of Sample">Possible interpretations of Behemoth and Leviathan</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_30" title="Link target outside of Sample">Evidence for Behemoth and Leviathan as symbols of supernatural chaos and evil</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_31" title="Link target outside of Sample">The hopeful and comforting implications of <span class="smallcaps_rom2">yhwh</span>’s second speech</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch04#sigil_toc_id_32" title="Link target outside of Sample">The limitations of God’s second speech to Job</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PL_ch05" title="Link target outside of Sample"><span class="bold2">5 Job’s restoration and the question of theodicy (ch. 42)</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch05#sigil_toc_id_34" title="Link target outside of Sample">‘Now my eye sees you’: Job’s second response (42:1–6)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch05#sigil_toc_id_35" title="Link target outside of Sample">Job’s restoration (42:7–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch05#sigil_toc_id_36" title="Link target outside of Sample">The book of Job and the question of theodicy</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PL_ch05#sigil_toc_id_37" title="Link target outside of Sample">The unique contribution of the book of Job to suffering and the problem of evil</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PL_ch06" title="Link target outside of Sample"><span class="bold2">6 Summary and conclusion</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PL_bibliog" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_ind_aut" title="Link target outside of Sample">Search items for authors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_ind_scr" title="Link target outside of Sample">Search terms for Scripture references</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_sertit" title="Link target outside of Sample">Titles in this series:</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_ata" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PL_IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PL_contents.vue?735fcd89